import { ProductComparisonData, ProductModel, BaseFeature } from "./types";

// ویژگی‌های پایه برای حلقه‌های هوشمند
const smartRingBaseFeatures: BaseFeature[] = [
    {
        feature: "وزن",
        description: "وزن دستگاه برای استفاده روزانه",
    },
    {
        feature: "جنس بدنه",
        description: "متریال ضدحساسیت و مقاوم",
    },
    {
        feature: "رنگ‌بندی",
        description: "رنگ‌های متنوع و قابل انتخاب",
    },
    {
        feature: "گواهی ضد آب",
        description: "مناسب برای شستشو یا باران",
    },
    {
        feature: "درجه دقت حسگرها",
        description: "میزان دقت در پایش سلامت",
    },
    {
        feature: "عمر باتری",
        description: "مدت زمان نگهداری شارژ",
    },

    {
        feature: "شارژ بی‌سیم",
        description: "شارژ بدون نیاز به کابل",
    },
    {
        feature: "پایش سلامت پیوسته و ۲۴ ساعته",
        description: "رصد دائمی علائم حیاتی در طول شبانه‌روز",
    },
    {
        feature: "ضربان قلب",
        description: "پایش مداوم سلامت قلب",
    },
    {
        feature: "تغییرات HRV",
        description: "تحلیل استرس و ریکاوری",
    },
    {
        feature: "سطح اکسیژن خون (SpO2)",
        description: "بررسی سطح اکسیژن در خون",
    },
    {
        feature: "ECG (نوار قلب)",
        description: "تشخیص بی‌نظمی‌های قلب",
    },
    {
        feature: "VO2max",
        description: "سنجش توان هوازی بدن",
    },
    {
        feature: "روند انرژی و متابولیسم",
        description: "پایش غیرتهاجمی شاخص‌های انرژی",
    },
    {
        feature: "پایش خواب",
        description: "تحلیل کیفیت خواب شبانه",
    },
    {
        feature: "نرخ تنفس",
        description: "تعداد تنفس در دقیقه",
    },
    {
        feature: "دمای پوست",
        description: "پایش تغییرات دمای بدن",
    },
    {
        feature: "قدم‌شمار",
        description: "شمارش قدم‌های روزانه",
    },
    {
        feature: "حالت ورزشی",
        description: "پایش فعالیت‌های ورزشی و تناسب اندام",
    },
    {
        feature: "سطح استرس",
        description: "ارزیابی تنش روزانه",
    },
    {
        feature: "ژست‌های حرکتی",
        description: "کنترل با ضربه یا حرکت دست",
    },
    {
        feature: "تماس اضطراری",
        description: "ارسال هشدار در شرایط خطر",
    },

    {
        feature: "API توسعه‌دهنده",
        description: "دسترسی به داده برای برنامه‌نویس",
    },
    {
        feature: "اشتراک‌گذاری سلامت با خانواده و اعضا",
        description: "امکان ارسال وضعیت سلامت به عزیزان",
    },
];

// محصولات دسته پزشکی
const medicalRings: ProductModel[] = [
    {
        id: "EVR-X6",
        title: "EVR-X6",
        icon: "/media/products/rings/EVR-X6.webp",
        colorClass: "from-rose-400 to-pink-600",
        category: "medical",
        features: [
            { feature: "وزن", value: "فوق‌العاده سبک حدود ۲ تا ۳ گرم (ضخامت 2.2mm، پهنا 8.0mm)" },
            { feature: "جنس بدنه", value: "آلیاژ تیتانیوم مقاوم درجه یک (Titanium)" },
            { feature: "رنگ‌بندی", value: "رزگلد، نقره‌ای، مشکی، طلایی" },
            { feature: "گواهی ضد آب", value: "5ATM (مقاوم تا عمق ۵۰ متری - مناسب شنا و استفاده روزمره)" },
            { feature: "درجه دقت حسگرها", value: "بسیار بالا مجهز به سنسور حرارتی تخصصی دمای پایه بدن (BBT) و ماژول اپتیکال PPG" },
            { feature: "عمر باتری", value: "7 تا 10 روز (شارژ سریع در کمتر از ۲ ساعت)" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: "پایش مداوم و شبانه‌روزی اکسیژن خون (SpO2)" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: "ارزیابی غیرتهاجمی روند انرژی" },
            { feature: "پایش خواب", value: "پایش تخصصی فازهای خواب (Light/Deep/REM)، نمره خواب، Fuel Score و کیفیت استراحت" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: "پایش پیوسته دمای پوست و دمای پایه بدن در خواب (BBT Tracking)" },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: "پایش ۲۴ ساعته سطح استرس، شاخص VitalAge و آمادگی ریکاوری" },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "تخصصی و پیشرفته (پایش دمای شبانه BBT، پیش‌بینی دقیق چرخه قاعدگی، زمان تخمک‌گذاری و بارداری)" },
            { feature: "حالت ورزشی", value: "پایش فعالیت روزانه، کالری مصرفی، مسافت و مودهای ورزشی چندگانه" },
            { feature: "مود ورزشی", value: "Multi-Sport" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
        ],
    },
    {
        id: "EVR-X5",
        title: "EVR-X5",
        icon: "/media/products/rings/EVR-X5.webp",
        colorClass: "from-amber-500 to-amber-700",
        category: "medical",
        features: [
            { feature: "وزن", value: "فوق‌العاده باریک (ضخامت 2.2mm، پهنا 8.0mm)" },
            { feature: "جنس بدنه", value: "سرامیک پیشرفته زیرکونیا / تیتانیوم (Ceramic/Titanium)" },
            { feature: "رنگ‌بندی", value: "مشکی براق سرامیکی، نقره‌ای، طلایی" },
            { feature: "گواهی ضد آب", value: "5ATM (مناسب شنا و فعالیت‌های آبی)" },
            { feature: "درجه دقت حسگرها", value: "بالا همراه با حسگر کنترل لمسی هوشمند (Smart Touch)" },
            { feature: "عمر باتری", value: "5 تا 10 روز (شارژ بی‌سیم سریع)" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: "پایش پیوسته اکسیژن خون شبانه‌روزی (SpO2)" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: "ارزیابی غیرتهاجمی روند انرژی" },
            { feature: "پایش خواب", value: "پایش خودکار خواب (Light/Deep/REM)، نمره خواب و ریکاوری" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: "دارای کنترل لمسی هوشمند (Touch Control) برای تعامل با دستگاه‌ها" },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (پایش چرخه قاعدگی، پیش‌بینی دما و دوران بارداری)" },
            { feature: "حالت ورزشی", value: "بیش از ۵۴ حالت ورزشی تخصصی + VO2Max" },
            { feature: "مود ورزشی", value: "۵۴+ حالت ورزشی" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
        ],
    },
    {
        id: "EVR-X2",
        title: "EVR-X2",
        icon: "/media/products/rings/EVR-X2.webp",
        colorClass: "from-indigo-500 to-purple-600",
        category: "medical",
        features: [
            { feature: "وزن", value: "فوق‌العاده سبک و ارگونومیک (پهنا 8.0 میلی‌متر)" },
            { feature: "جنس بدنه", value: "آلیاژ تیتانیوم مقاوم و سبک (Titanium)" },
            { feature: "رنگ‌بندی", value: "مشکی، نقره‌ای، خاکستری، طلایی" },
            { feature: "گواهی ضد آب", value: "5ATM (مناسب شنا و استفاده روزمره)" },
            { feature: "درجه دقت حسگرها", value: "بسیار بالا و بهینه‌شده برای پایش خواب (ماژول مادون‌قرمز PPG)" },
            { feature: "عمر باتری", value: "5 تا 7 روز (پایش مداوم هفتگی بدون وقفه)" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: "پایش شبانه SpO2 و نوسانات اکسیژن خواب" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: "پایش تخصصی فازهای خواب (Light/Deep/REM)، نمره ریکاوری HRV و پایش پیوسته" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (پایش چرخه قاعدگی و بارداری)" },
            { feature: "حالت ورزشی", value: "بیش از ۵۴ حالت ورزشی متنوع + سنجش VO2Max" },
            { feature: "مود ورزشی", value: "۵۴+ حالت ورزشی" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
        ],
    },
    {
        id: "EVR-X3",
        title: "EVR-X3",
        icon: "/media/products/rings/EVR-X3.webp",
        colorClass: "from-cyan-500 to-blue-600",
        category: "medical",
        features: [
            { feature: "وزن", value: "3.4g (فوق‌العاده سبک، ضخامت 2.7mm)" },
            { feature: "جنس بدنه", value: "آلیاژ تیتانیوم درجه هوافضا (Titanium)" },
            { feature: "رنگ‌بندی", value: "مشکی مات، نقره‌ای، رزگلد، طلایی" },
            { feature: "گواهی ضد آب", value: "5ATM (مناسب شنا و ورزش‌های آبی)" },
            { feature: "درجه دقت حسگرها", value: "دقت بالا (سنسور ترانسمیسیون SpO2 با دقت ±2.7%)" },
            { feature: "عمر باتری", value: "7+ روز (شارژ بی‌سیم سریع کمتر از ۹۰ دقیقه)" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: "پایش پیوسته + ارزیابی الگوی تنفس خواب" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: "ارزیابی غیرتهاجمی روند انرژی (AI Energy)" },
            { feature: "پایش خواب", value: "پایش پیشرفته فازهای خواب (REM/Deep) و کیفیت تنفس" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (پایش چرخه قاعدگی و بارداری)" },
            { feature: "حالت ورزشی", value: "بیش از ۵۴ حالت ورزشی تخصصی + VO2Max" },
            { feature: "مود ورزشی", value: "۵۴+ حالت ورزشی متنوع" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
        ],
    },
    {
        id: "EVR-XE10",
        title: "EVR-XE10",
        icon: "/media/products/rings/EVR-XE10.webp",
        colorClass: "from-blue-400 to-blue-600",
        category: "medical",
        features: [
            { feature: "وزن", value: "3.6 - 4.2g" },
            { feature: "جنس بدنه", value: "استیل ضدزنگ (PVD)" },
            { feature: "رنگ‌بندی", value: "مشکی" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "درجه دقت حسگرها", value: "بالا (با الگوریتم‌های هوش مصنوعی)" },
            { feature: "عمر باتری", value: "4 تا 5 روز" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: false },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "ندارد" },
            { feature: "مود ورزشی", value: "پایه‌ای (گام‌شمار و فعالیت)" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: false },
            { feature: "حالت ورزشی", value: false },
        ],
    },
    {
        id: "EVR-X30",
        title: "EVR-X30",
        icon: "/media/products/rings/EVR-X30.webp",
        colorClass: "from-orange-300 to-orange-500",
        category: "medical",
        features: [
            { feature: "وزن", value: "2 - 3g" },
            { feature: "جنس بدنه", value: "تیتانیوم" },
            { feature: "رنگ‌بندی", value: "نقره‌ای، مشکی، طلایی" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "بسیار بالا (تخصصی بانوان)" },
            { feature: "عمر باتری", value: "7 روز" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "تخصصی (پایش قاعدگی، تخمک‌گذاری و هورمون‌ها)" },
            { feature: "مود ورزشی", value: "چندگانه (پایش VO2max و ریکاوری)" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
            { feature: "حالت ورزشی", value: true },
        ],
    },
    {
        id: "EVR-XE15",
        title: "EVR-XE15",
        icon: "/media/products/rings/EVR-XE15.webp",
        colorClass: "from-gray-700 to-gray-900",
        category: "medical",
        features: [
            { feature: "وزن", value: "4.2g" },
            { feature: "جنس بدنه", value: "آلیاژ فلزی مقاوم" },
            { feature: "رنگ‌بندی", value: "مشکی براق (Full-light black)" },
            { feature: "گواهی ضد آب", value: "مقاوم در برابر نفوذ آب" },
            { feature: "درجه دقت حسگرها", value: "بالا (تراشه‌های Goodix 3228T و Nordic)" },
            { feature: "عمر باتری", value: "4 تا 6 روز" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "پایش گردش خون", value: true },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "ندارد" },
            { feature: "مود ورزشی", value: "پشتیبانی می‌شود (توسط سنسور شتاب‌سنج STK8321)" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
            { feature: "حالت ورزشی", value: false },
        ],
    },
    {
        id: "EVR-X60",
        title: "EVR-X60",
        icon: "/media/products/rings/EVR-X60.webp",
        colorClass: "from-blue-600 to-blue-800",
        category: "medical",
        features: [
            { feature: "وزن", value: "3.4g" },
            { feature: "جنس بدنه", value: "تیتانیوم" },
            { feature: "رنگ‌بندی", value: "بافت فلزی کلاسیک" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "دقت بالا (High-Precision)" },
            { feature: "عمر باتری", value: "7 روز" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (قاعدگی، دوره‌های باروری و بارداری)" },
            { feature: "مود ورزشی", value: "حرفه‌ای (تشخیص مناطق ضربان قلب ورزشی)" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
            { feature: "حالت ورزشی", value: true },
        ],
    },
    {
        id: "medical-ring-1",
        title: "EVR-X10",
        icon: "/media/products/rings/ring1.webp",
        rotation: 250,
        colorClass: "from-blue-200 to-blue-300",
        category: "medical",
        features: [
            { feature: "درجه دقت حسگرها", value: "خیلی بالا" },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "VO2max", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: true },
            { feature: "جنس بدنه", value: "تیتانیوم" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "عمر باتری", value: "10 روز" },
            { feature: "رنگ‌بندی", value: "مشکی / نقره‌ای / طلایی" },
            { feature: "وزن", value: "5 گرم" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
            { feature: "حالت ورزشی", value: true },
        ],
    },
    {
        id: "medical-ring-2",
        title: "EVR-X20",
        icon: "/media/products/rings/ring7.webp",
        colorClass: "from-blue-200 to-blue-300",
        category: "medical",
        features: [
            { feature: "درجه دقت حسگرها", value: "خیلی بالا" },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "VO2max", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: true },
            { feature: "جنس بدنه", value: "تیتانیوم" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "عمر باتری", value: "7 روز" },
            { feature: "رنگ‌بندی", value: "مشکی / نقره‌ای / طلایی" },
            { feature: "وزن", value: "5 گرم" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
            { feature: "حالت ورزشی", value: true },
        ],
    },
    {
        id: "medical-ring-3",
        title: "EVR-V4",
        icon: "/media/products/rings/ring6.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "standard",
        rotation: 260,
        features: [
            { feature: "درجه دقت حسگرها", value: "بالا" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: true },
            { feature: "جنس بدنه", value: "استیل" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "رنگ‌بندی", value: "مشکی / نقره‌ای" },
            { feature: "وزن", value: "6 گرم" },
            { feature: "عمر باتری", value: "7 روز" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: true },
            { feature: "حالت ورزشی", value: true },
        ],
    },
    {
        id: "medical-ring-4",
        title: "EVR-V3",
        icon: "/media/products/rings/ring5.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "standard",
        features: [
            { feature: "درجه دقت حسگرها", value: "متوسط" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: false },
            { feature: "سطح استرس", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "جنس بدنه", value: "استیل" },
            { feature: "گواهی ضد آب", value: "3ATM" },
            { feature: "رنگ‌بندی", value: "مشکی" },
            { feature: "وزن", value: "7 گرم" },
            { feature: "عمر باتری", value: "7 روز" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: false },
            { feature: "حالت ورزشی", value: false },
        ],
    },
    {
        id: "medical-ring-5",
        title: "EVR-V1",
        icon: "/media/products/rings/ring9.webp",
        colorClass: "from-green-200 to-green-300",
        category: "economic",
        features: [
            { feature: "درجه دقت حسگرها", value: "پایین" },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: false },
            { feature: "سطح استرس", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "جنس بدنه", value: "پلاستیک" },
            { feature: "گواهی ضد آب", value: "3ATM" },
            { feature: "رنگ‌بندی", value: "ساده" },
            { feature: "وزن", value: "8 گرم" },
            { feature: "عمر باتری", value: "10 روز" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
            { feature: "پایش استرس", value: false },
            { feature: "حالت ورزشی", value: false },
        ],
    },
];

// محصولات دسته استاندارد
const standardRings: ProductModel[] = [
    {
        id: "standard-ring-1",
        title: "EVR-S1",
        icon: "/media/products/rings/ring10.webp",
        colorClass: "from-blue-200 to-blue-300",
        category: "standard",
        rotation: 40,
        features: [
            { feature: "وزن", value: "4 گرم" },
            { feature: "جنس بدنه", value: "تیتانیوم" },
            { feature: "رنگ‌بندی", value: "نقره‌ای، مشکی، آبی" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "درجه دقت حسگرها", value: "متوسط" },
            { feature: "عمر باتری", value: "3 روز" },

            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: true },
            { feature: "ردیابی موقعیت", value: false },
            { feature: "API توسعه‌دهنده", value: true },
        ],
    },
    {
        id: "standard-ring-2",
        title: "EVR-S2",
        icon: "/media/products/rings/ring23.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "standard",
        rotation: 35,
        features: [
            { feature: "وزن", value: "5 گرم" },
            { feature: "جنس بدنه", value: "استیل ضدزنگ" },
            { feature: "رنگ‌بندی", value: "طلایی، نقره‌ای، مشکی" },
            { feature: "گواهی ضد آب", value: "IP67" },
            { feature: "درجه دقت حسگرها", value: "استاندارد" },
            { feature: "عمر باتری", value: "4 روز" },

            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: true },
            { feature: "ردیابی موقعیت", value: false },
            { feature: "API توسعه‌دهنده", value: true },
        ],
    },
    {
        id: "standard-ring-3",
        title: "EVR-S3",
        icon: "/media/products/rings/ring11.webp",
        colorClass: "from-green-200 to-green-300",
        category: "standard",
        rotation: 30,
        features: [
            { feature: "وزن", value: "6 گرم" },
            { feature: "جنس بدنه", value: "آلومینیوم" },
            { feature: "رنگ‌بندی", value: "خاکستری، سبز" },
            { feature: "گواهی ضد آب", value: "3ATM" },
            { feature: "درجه دقت حسگرها", value: "متوسط" },
            { feature: "عمر باتری", value: "3 روز" },

            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: false },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: false },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "ردیابی موقعیت", value: false },
            { feature: "API توسعه‌دهنده", value: false },
        ],
    },
    {
        id: "standard-ring-4",
        title: "EVR-S4",
        icon: "/media/products/rings/ring24.webp",
        colorClass: "from-blue-200 to-blue-300",
        category: "standard",
        rotation: 70,
        features: [
            { feature: "وزن", value: "5.5 گرم" },
            { feature: "جنس بدنه", value: "فولاد سبک" },
            { feature: "رنگ‌بندی", value: "مشکی، آبی نفتی" },
            { feature: "گواهی ضد آب", value: "IP66" },
            { feature: "درجه دقت حسگرها", value: "متوسط" },
            { feature: "عمر باتری", value: "3.5 روز" },

            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: false },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: true },
            { feature: "ردیابی موقعیت", value: false },
            { feature: "API توسعه‌دهنده", value: true },
        ],
    },
];

const economicRings: ProductModel[] = [
    {
        id: "economic-ring-1",
        title: "EVR-Q5",
        icon: "/media/products/rings/ring3.webp",
        colorClass: "from-blue-200 to-blue-300",
        category: "economic",
        features: [
            { feature: "وزن", value: "2.5g" },
            { feature: "جنس بدنه", value: "آلیاژ تیتانیوم" },
            { feature: "رنگ‌بندی", value: "مشکی، نقره ای، طلایی" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "معمولی" },
            { feature: "عمر باتری", value: "7 روز" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "مود ورزشی", value: false },
            { feature: "سلامت بانوان", value: false },
        ],
    },
    {
        id: "economic-ring-2",
        title: "EVR-Q8",
        icon: "/media/products/rings/ring13.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "economic",
        rotation: 200,
        features: [
            { feature: "وزن", value: "4g" },
            { feature: "جنس بدنه", value: "استیل ضد زنگ" },
            { feature: "رنگ‌بندی", value: "مشکی، طلایی، نقره ای" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "معمولی" },
            { feature: "عمر باتری", value: "6 روز" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "مود ورزشی", value: false },
            { feature: "سلامت بانوان", value: false },
        ],
    },
    {
        id: "economic-ring-3",
        title: "EVR-Q5L",
        icon: "/media/products/rings/ring4.webp",
        colorClass: "from-green-200 to-green-300",
        category: "economic",
        features: [
            { feature: "وزن", value: "3.1g" },
            { feature: "جنس بدنه", value: "آلیاژ تیتانیوم" },
            { feature: "رنگ‌بندی", value: "مشکی، طلایی، نقره ای" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "معمولی" },
            { feature: "عمر باتری", value: "5 روز" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "مود ورزشی", value: false },
            { feature: "سلامت بانوان", value: false },
        ],
    },
    {
        id: "economic-ring-4",
        title: "EVR-Q9",
        icon: "/media/products/rings/ring21.webp",
        colorClass: "from-blue-200 to-blue-300",
        category: "economic",
        features: [
            { feature: "وزن", value: "4.5g" },
            { feature: "جنس بدنه", value: "استیل ضد زنگ" },
            { feature: "رنگ‌بندی", value: "مشکی، طلایی، نقره ای" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "معمولی" },
            { feature: "عمر باتری", value: "9 روز" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: false },
            { feature: "ژست‌های حرکتی", value: true },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "مود ورزشی", value: false },
            { feature: "سلامت بانوان", value: false },
        ],
    },
    {
        id: "economic-ring-5",
        title: "EVR-Q10N",
        icon: "/media/products/rings/ring22.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "economic",
        features: [
            { feature: "وزن", value: "8g" },
            { feature: "جنس بدنه", value: "سرامیک" },
            { feature: "رنگ‌بندی", value: "صورتی، نقره ای، مشکی" },
            { feature: "گواهی ضد آب", value: "5ATM" },
            { feature: "درجه دقت حسگرها", value: "معمولی" },
            { feature: "عمر باتری", value: "6 روز" },
            { feature: "شارژ بی‌سیم", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: false },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: true },
            { feature: "NFC", value: false },
            { feature: "مود ورزشی", value: false },
            { feature: "سلامت بانوان", value: false },
        ],
    },
];
// ترکیب همه محصولات
const allRings = [...medicalRings, ...standardRings, ...economicRings];

// داده‌های نهایی برای حلقه‌های هوشمند
export const smartRingsData: ProductComparisonData = {
    baseFeatures: smartRingBaseFeatures,
    categories: [
        { id: "all", label: "همه", products: allRings },
        { id: "medical", label: "پیشرو", products: medicalRings },
        { id: "standard", label: "استاندارد", products: standardRings },
        { id: "economic", label: "اقتصادی", products: economicRings },
    ],
    allProducts: allRings,
};
